import { render } from "./rightMenu.vue?vue&type=template&id=0495a710&scoped=true"
import script from "./rightMenu.vue?vue&type=script&lang=js"
export * from "./rightMenu.vue?vue&type=script&lang=js"

import "./rightMenu.vue?vue&type=style&index=0&id=0495a710&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0495a710"]])

export default __exports__